export const MINI_WORDS = [
  'swoop',
  'beige',
  'rebel',
  'cease',
  'undue',
  'embed',
  'hence',
  'parka',
  'condo',
  'exert',
  'booty',
  'hippo',
  'creep',
  'cynic',
  'dwell',
  'error',
  'fuzzy',
  'ensue',
  'marry',
  'rigor',
  'amiss',
  'cliff',
  'rower',
  'verge',
  'meter',
  'amaze',
  'tease',
  'dodge',
  'revel',
  'merge',
  'sends',
  'xenon',
  'legal',
  'shall',
  'mimic',
  'apart',
  'mafia',
  'bliss',
  'honor',
  'gamma',
  'evade',
  'barre',
  'juror',
  'belly',
  'motor',
  'bless',
  'steer',
  'excel',
  'llama',
  'libel',
  'bluff',
  'bossy',
  'terra',
  'afoot',
  'tight',
  'seeds',
  'canal',
  'start',
  'spell',
  'arena',
  'tutor',
  'needy',
  'these',
  'tooth',
  'knoll',
  'posse',
  'karma',
  'vroom',
  'taste',
  'bezel',
  'torso',
  'dined',
  'issue',
  'essay',
  'aroma',
  'brook',
  'photo',
  'melee',
  'hedge',
  'wedge',
  'kiosk',
  'trait',
  'ledge',
  'muddy',
  'taboo',
  'chaff',
  'promo',
  'loyal',
  'buddy',
  'rally',
  'fugue',
  'khaki',
  'sever',
  'creek',
  'teeth',
  'stint',
  'silly',
  'toast',
  'carry',
  'upped',
  'faded',
  'peeve',
  'glass',
  'occur',
  'avian',
  'colon',
  'awash',
  'every',
  'order',
  'stood',
  'fleet',
  'villa',
  'sassy',
  'stool',
  'array',
  'lotto',
  'chuck',
  'foggy',
  'skull',
  'abbey',
  'mania',
  'banal',
  'grill',
  'genre',
  'forgo',
  'nerve',
  'aloof',
  'geese',
  'jaded',
  'siege',
  'tense',
  'beefy',
  'otter',
  'piper',
  'added',
  'check',
  'drool',
  'level',
  'hurry',
  'theft',
  'peace',
  'catch',
  'limit',
  'circa',
  'sleet',
  'chess',
  'groom',
  'witty',
  'vivid',
  'sofas',
  'shoot',
  'niece',
  'suede',
  'moose',
  'lowly',
  'utter',
  'ether',
  'tasty',
  'crepe',
  'pixie',
  'aural',
  'hatch',
  'creed',
  'hunch',
  'cocky',
  'aging',
  'valve',
  'cubic',
  'again',
  'ceded',
  'dress',
  'slash',
  'obese',
  'rumor',
  'greed',
  'shush',
  'genie',
  'shook',
  'comic',
  'rover',
  'arrow',
  'chili',
  'ember',
  'atlas',
  'fluff',
  'skunk',
  'state',
  'annoy',
  'total',
  'seams',
  'gross',
  'bleep',
  'sieve',
  'erode',
  'roost',
  'larva',
  'river',
  'blood',
  'kinky',
  'sleek',
  'sniff',
  'geeky',
  'sinus',
  'atoll',
  'inner',
  'swish',
  'linen',
  'gloss',
  'cache',
  'aback',
  'wheel',
  'sweet',
  'modem',
  'alpha',
  'fever',
  'femme',
  'panda',
  'sweep',
  'baggy',
  'gouge',
  'indie',
  'mommy',
  'stoop',
  'merry',
  'diode',
  'erase',
  'bully',
  'fussy',
  'arbor',
  'spree',
  'proof',
  'award',
  'rarer',
  'smash',
  'press',
  'local',
  'reset',
  'deeds',
  'titan',
  'greet',
  'keyed',
  'jolly',
  'duped',
  'snoop',
  'breed',
  'queer',
  'digit',
  'areas',
  'harsh',
  'basis',
  'hobby',
  'alias',
  'steel',
  'loose',
  'pagan',
  'gooey',
  'slabs',
  'madam',
  'bleed',
  'elude',
  'matte',
  'nylon',
  'salad',
  'event',
  'grass',
  'dense',
  'poppy',
  'motto',
  'swell',
  'defer',
  'spook',
  'ruler',
  'shell',
  'maxim',
  'brood',
  'broom',
  'dread',
  'altar',
  'razer',
  'apnea',
  'queen',
  'coach',
  'boson',
  'eased',
  'riser',
  'skill',
  'never',
  'drier',
  'cross',
  'vexed',
  'puppy',
  'venue',
  'weave',
  'curry',
  'stash',
  'runny',
  'scoot',
  'emcee',
  'lease',
  'ahead',
  'delve',
  'whiff',
  'clock',
  'beret',
  'gloom',
  'ferry',
  'ionic',
  'knack',
  'patty',
  'petty',
  'scoff',
  'rodeo',
  'fewer',
  'jelly',
  'jazzy',
  'parry',
  'magma',
  'druid',
  'amass',
  'soggy',
  'arias',
  'stuff',
  'twist',
  'await',
  'latte',
  'sewed',
  'pizza',
  'usual',
  'ditto',
  'cocoa',
  'outdo',
  'sheep',
  'booed',
  'knock',
  'seedy',
  'fatal',
  'there',
  'sewer',
  'dazed',
  'fence',
  'manga',
  'renew',
  'plaza',
  'rigid',
  'erred',
  'color',
  'cacti',
  'oddly',
  'koala',
  'serve',
  'bongo',
  'agree',
  'eagle',
  'erect',
  'stabs',
  'canny',
  'verse',
  'spasm',
  'sexes',
  'radar',
  'sauna',
  'crack',
  'spoof',
  'dryer',
  'troop',
  'celeb',
  'tapas',
  'cacao',
  'gruff',
  'taffy',
  'mamma',
  'going',
  'outro',
  'convo',
  'muses',
  'goofy',
  'lasso',
  'cheek',
  'eager',
  'quell',
  'boron',
  'crock',
  'putty',
  'union',
  'onion',
  'blurb',
  'title',
  'slush',
  'agave',
  'tacit',
  'tarot',
  'droid',
  'heave',
  'quill',
  'caddy',
  'petit',
  'daddy',
  'salsa',
  'rider',
  'kitty',
  'cello',
  'oasis',
  'aided',
  'fryer',
  'yummy',
  'sheen',
  'offer',
  'timid',
  'kebab',
  'ended',
  'avail',
  'ninja',
  'spill',
  'visit',
  'alibi',
  'sodas',
  'piece',
  'pasta',
  'steed',
  'queue',
  'newer',
  'tally',
  'gorge',
  'drama',
  'couch',
  'fauna',
  'dizzy',
  'alarm',
  'leave',
  'green',
  'lilac',
  'dried',
  'prior',
  'robot',
  'stiff',
  'theme',
  'rotor',
  'trust',
  'rerun',
  'eaten',
  'deter',
  'sizes',
  'donor',
  'ashes',
  'combo',
  'alloy',
  'livid',
  'dived',
  'boost',
  'elder',
  'lever',
  'alley',
  'rural',
  'click',
  'elect',
  'thigh',
  'tiara',
  'piped',
  'seize',
  'naval',
  'taint',
  'floss',
  'isles',
  'tract',
  'pupil',
  'hutch',
  'deere',
  'slugs',
  'aorta',
  'crass',
  'mamas',
  'lipid',
  'cabal',
  'discs',
  'sheer',
  'domed',
  'fuses',
  'apple',
  'agora',
  'refer',
  'upper',
  'idiom',
  'apply',
  'sheet',
  'aware',
  'freed',
  'brass',
  'aloha',
  'which',
  'mummy',
  'label',
  'pooch',
  'sense',
  'greek',
  'retro',
  'known',
  'strut',
  'gauge',
  'comma',
  'allow',
  'levee',
  'where',
  'awake',
  'dated',
  'booze',
  'messy',
  'steep',
  'icing',
  'lapel',
  'lobby',
  'exile',
  'evoke',
  'canon',
  'annex',
  'repel',
  'speed',
  'algae',
  'treat',
  'nasal',
  'berry',
  'razor',
  'jewel',
  'hitch',
  'tempt',
  'assay',
  'tweet',
  'scene',
  'ozone',
  'eject',
  'eerie',
  'leech',
  'spool',
  'booth',
  'moody',
  'flood',
  'cycle',
  'stout',
  'stall',
  'bribe',
  'enemy',
  'dared',
  'spoon',
  'gurus',
  'sunny',
  'teeny',
  'trout',
  'sleep',
  'reuse',
  'jello',
  'diced',
  'sushi',
  'savvy',
  'tithe',
  'troll',
  'adage',
  'stunt',
  'bloom',
  'taunt',
  'chill',
  'bunny',
  'chock',
  'goose',
  'class',
  'dodgy',
  'giddy',
  'totem',
  'scoop',
  'attic',
  'elite',
  'still',
  'asset',
  'happy',
  'civil',
  'small',
  'edged',
  'enter',
  'drill',
  'truth',
  'funny',
  'staff',
  'armor',
  'guess',
  'paper',
  'smell',
  'floor',
  'kneel',
  'abyss',
  'cheer',
  'swoon',
  'conch',
  'chick',
  'expel',
  'puree',
  'carat',
  'adapt',
  'sided',
  'puffy',
  'kayak',
  'vigil',
  'spies',
  'friar',
  'crook',
  'trite',
  'racer',
  'plump',
]
